import API from "Services/Api";

export async function getCognitoToken() {
  try {
    const response = await API.get("/cognito");
    return response.data.access_token;
  } catch (error) {
    console.log(error);
  }
}
